module.exports = __webpack_public_path__ + "static/media/RetweetSmall.b953a869.svg";